import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'dc-layout',
  styleUrls: ['./layout.component.less'],
  templateUrl: './layout.component.html',
})
export class LayoutComponent implements OnInit {
  public data: {
    hideNavigation?: boolean;
  } = {};

  constructor(private Router: Router, private ActivatedRoute: ActivatedRoute) {}

  ngOnInit() {
    this.Router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      let data = {};
      let route: ActivatedRouteSnapshot | null = this.ActivatedRoute.snapshot.root;

      do {
        data = Object.assign(data, route.data);
        route = route.firstChild;
      } while (route);

      this.data = data;
    });
  }
}
